import { dataZoomInSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconZoomInSolid = /*#__PURE__*/createIcon(dataZoomInSolid)
export default IconZoomInSolid
